import React, {Component, Fragment} from 'react';
import DEFINE, {HOTEL as ENUM_HOTEL, PATHS, FEATURE_FLAGS} from "../../../../constants/Define";
import {Link} from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import PostList from './PostList';
import Ripple from '../../common/component/Ripple';

let permisionActions = [];
export default class Posts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.postState.pageSize,
                pageIndex: this.props.postState.pageIndex,
            },
        };
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.POST);
        this.props.getListPosts(this.state.filters);
    }

    render() {
        const {t} = this.props;
        const {isFetching, totalCount, totalPage, pageIndex, pageSize, posts} = this.props.postState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'posts'}
                        titleHeader={t('navigation.posts')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={PATHS.POST.CREATE.path}
                                          className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <PostList loading={isFetching}
                              permisions={permisionActions}
                              posts={posts}
                              pagination={pagination}
                              onChange={this.onTableChange}
                              onDeletePost={this.onDeletePost}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getListPosts(newFilters);
    };

    onDeletePost = (item) => {        
        this.props.deletePostDetail(item, this.state.filters);
    }

    onChangeLanguage = (language) => {
        this.props.getListPosts(this.state.filters)
    }


}
